export { default } from './DocumentationFragment';
